{
  "id": "001-004",
  "title": "Making moves",
  "version": 0,
  "layout": {
    "tiles": {
      "0": {
        "0": {
          "id": "f7e82775",
          "type": "tile"
        },
        "1": {
          "id": "a6a13b50",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 4
                }
              ],
              "id": "9e1641ff"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "d7cf5d82"
            }
          ]
        },
        "-1": {
          "id": "da5ab990",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 1
                }
              ],
              "id": "ecb4ba7d"
            }
          ]
        }
      },
      "1": {
        "0": {
          "id": "926dd5c2",
          "type": "tile"
        },
        "-1": {
          "id": "e1f07200",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 2,
                  "toggled": true
                }
              ],
              "id": "9445dc49"
            }
          ],
          "modifiers": [
            {
              "type": "swap",
              "id": "4db41948"
            },
            {
              "type": "rotate",
              "id": "607154d3",
              "clockwise": false
            }
          ]
        }
      },
      "-1": {
        "0": {
          "id": "ee3c0f2f",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 5,
                  "toggled": true
                }
              ],
              "id": "ffca60ee"
            }
          ],
          "modifiers": [
            {
              "type": "move",
              "id": "9a35f620"
            }
          ]
        },
        "-1": {
          "id": "4c7af20d",
          "type": "tile"
        }
      }
    }
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 2
    }
  ]
}
